import { render, staticRenderFns } from "./external-window.vue?vue&type=template&id=8325555a"
import script from "./external-window.vue?vue&type=script&lang=js"
export * from "./external-window.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports